import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-currency-readonly',
  templateUrl: './input-currency-readonly.component.html',
  styleUrls: ['./input-currency-readonly.component.scss']
})
export class InputCurrencyReadonlyComponent implements OnInit {

  @Input() public currency: any = '';
  @Input() public error: any;
  @Input() public disabled: any;
  @Input() public preffix: any;
  @Output() callback: EventEmitter<any> = new EventEmitter;
  noValid:any;


  constructor() { 
    this.noValid=false;}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('recibiendo currency de padre');
    if (changes.currency && changes.currency.currentValue) {
      this.format();
    }
  }

  onNgModelChanges($event) {
    //console.log('event ', $event);
    //console.log('se ha modificado la cantidad', this.currency);
    this.format();
    this.emit();
  }

  soloNumeros(e){
    var key = window.event ? e.which : e.keyCode;
    if (key < 48 || key > 57) {
      e.preventDefault();
    }
  }

  format() {
    if (!this.currency) {
      return '';
    }
    this.noValid = false;
    
    if(this.currency.toString().indexOf('.') > 0)
    {
      
      if(this.currency.toString().split('.').length > 2)
        this.currency = parseFloat(this.currency.toString().substr(0,-1));
      
      var cadena = this.currency.toString(),separador = ".",arregloDeSubCadenas = cadena.split(separador);
      //se agrega validacion para que el punto sea solo a los dos decimales
      if(arregloDeSubCadenas[1] !== undefined && !isNaN(arregloDeSubCadenas[1]))
        if(arregloDeSubCadenas[1].toString().length > 2)
          this.currency = ( arregloDeSubCadenas[0] !== undefined ? arregloDeSubCadenas[0].toString() : '')+arregloDeSubCadenas[1].toString().substr(0,1)+'.'+arregloDeSubCadenas[1].toString().substr(1);
              
        var cadena1 = arregloDeSubCadenas[1];
              if(cadena1 > 99){
                //console.log("mayor",cadena1);
                this.noValid = true;
              }
    }
    //console.log('formateando currency', this.currency);
    this.currency = this.currency.toString().replace(/\B(?=(\d{3})+(?!\d{3})+(?!\d))/g, ",");

  }

  getUnformat() {
    //const currencyUnformat = this.currency.replace(',','');
    const currencyUnformat = this.currency.replace(/,/g,'');
    //console.log('unformating', currencyUnformat);
    return currencyUnformat;
  }

  emit() {
    this.callback.emit(this.getUnformat());
    console.log('emitting ', this.getUnformat());
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/input-currency-readonly/input-currency-readonly.component.ts